import React, { useEffect, useRef, useState } from "react";
import Button from "../components/Button";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import pipelineImage from "../assets/pipeline_image.jpeg";
import "../styles/home_page.css";
import csvData from "../assets/Data_example.csv";
import banner from "../assets/aa.jpg";
import peie from "../assets/peie.jpg";
import { Steps } from 'antd';
import pro1 from "../assets/pro1.png";
import pro2 from "../assets/pro2.png";
import pro3 from "../assets/pro3.png";
import pro4 from "../assets/pro4.png";
import pro5 from "../assets/pro5.png";
import video from "../assets/trademaster.mp4";
export default function Home() {
  const navigate = useNavigate();
  const [dropdownVisible, setDropdownVisible] = useState(true);
  const showDropdown = () => {
    console.log('Dropdown should now be visible.');
    setDropdownVisible(true);
  };

  const CollapsibleBox_Platformoverview = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="collapsible-box">
        <button className="collapsible-button" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? "Hide Instructions" : "Show Instructions"}
        </button>

        {isOpen && (
          <div className="collapsible-content">
            <p className="instructions-container">
              Use the Market Dynamics Modeling Toolbox with these steps:
              <ol>
                <li>
                  Choose our dataset or upload your own dataset by ‘Upload Custom Dataset’ for market dynamics labeling (please prepare your custom dataset following this{" "}
                  <a
                    href={csvData}
                    download
                    style={{ textDecoration: "underline" }}
                  >
                    {" "}
                    sample csv file
                  </a>
                  )
                </li>
                <li>
                  Set the parameters and press ‘Run Market Dynamics Modeling’ button to
                  show the dynamics segmentation result of the current setting, you
                  may tune the parameters until you are satisfied with the result
                  (please refer to this{" "}
                  <a
                    href="https://github.com/TradeMaster-NTU/TradeMaster/blob/1.0.0/docs/source/tool/TradeMaster_Sandbox_whitepaper.pdf"
                    style={{ textDecoration: "underline" }}
                    target="_blank"
                  >
                    white paper
                  </a>
                  {" "}
                  for parameters tuning)
                </li>
                <li>
                  Press ‘Save & Download Current Modeling’ button when you are done tuning
                  parameters. The this will save and download current modeling result for you. (You may also
                  do this locally by using the{" "}
                  <a
                    href="https://github.com/TradeMaster-NTU/TradeMaster"
                    style={{ textDecoration: "underline" }}
                    target="_blank"
                  >
                    TradeMaster
                  </a>{" "}
                  and follow this{" "}
                  <a
                    href="https://github.com/TradeMaster-NTU/TradeMaster/blob/1.0.0/docs/source/tool/EvaluationSandbox_MDM.md"
                    style={{ textDecoration: "underline" }}
                    target="_blank"
                  >
                    tutorial
                  </a>{" "}
                </li>
                <li>
                  <strong>(Optional)</strong> If you have a trained agent from <strong><Link to="/service">the Training Page</Link></strong>, you may choose the tested dynamics and press ‘Test’ to test the agent you
                  trained on the “Agent Training” page.
                  )
                </li>
              </ol>
            </p>
          </div>
        )}
      </div>
    );
  };
  // @ts-ignore

  return (
    <div>
      <div className="homeMain">
        <div className="main1">TradeMaster</div>
        <div className="main3">Reinforcement Learning for Financial Trading</div>

        <div>
          <div className="do">
            <div className="what">WHAT WE DO</div>
            <div className="how">TradeMaster is a first-of-its kind, best-in-class open-source platform for quantitative trading (QT) empowered by reinforcement learning (RL), which covers the full pipeline for the design, implementation, evaluation and deployment of RL-based algorithms.</div>
          </div>
          <img
            src={banner}
            alt="github Icon"
            className="banner3"
          />

        </div>
      </div>



      <div className="home3" style={{marginTop:'40px',height:'440px'}}>
        <div className="home4">
          {/* <div className="do3">
            <div className="">Pipeline</div>
          </div> */}
          <div className="do3">
            <div className="">Our Projects</div>
          </div>
          <div className="project">
            <a href="https://github.com/TradeMaster-NTU/TradeMaster/">
              <div className="proItem">
                <img
                  src={pro1}
                  alt="github Icon"
                  className="proImg"
                />
                <div className="proText">TradeMaster: Holistic RL Platform</div>
              </div>
            </a>

            <a href="https://arxiv.org/abs/2402.18485">
              <div className="proItem">
                <img
                  src={pro2}
                  alt="github Icon"
                  className="proImg"
                />
                <div className="proText">FinAgent: Foundation Agent for Trading</div>
              </div>
            </a>

            <a href="https://github.com/DVampire/EarnMore">
              <div className="proItem">
                <img
                  src={pro3}
                  alt="github Icon"
                  className="proImg"
                />
                <div className="proText">RL for Portfolio Management</div>
              </div>
            </a>
            <a href="https://github.com/qinmoelei/EarnHFT">
              <div className="proItem">
                <img
                  src={pro4}
                  alt="github Icon"
                  className="proImg"
                />
                <div className="proText">RL for High Frequency Trading</div>
              </div>
            </a>
            <a href="https://github.com/TradeMaster-NTU/Market-GAN">
              <div className="proItem">
                <img
                  src={pro5}
                  alt="github Icon"
                  className="proImg"
                />
                <div className="proText">Realistic Market Simulator</div>
              </div>
            </a>

          </div>
        </div>

      </div>

      <div className="home5" style={{height:'730px'}}>
        <div className="do2">
          <div className="">Pipeline</div>
        </div>

        <img
          src={peie}
          alt="github Icon"
          className="banner4"
        />


      </div>

      {/* Parent container, similar to .home5 for “Pipeline” */}
      <div 
        style={{
          width: '1200px',
          margin: '0 auto',
          height: '600px',     // Enough height for title + video
          position: 'relative' // Required for absolutely positioned title
        }}
      >
        {/* Absolutely positioned heading */}
        <div 
          className="do2"
          style={{
            position: 'absolute',
            top: '-50px',  // Move heading 50px down from the container top
            left: 0,
            right: 0,     // Left+right = 0 ensures full width
            textAlign: 'center',
            margin: '0 auto'
          }}
        >
          <div>Guidance Video for Training</div>
        </div>

        {/* The video itself, also absolutely positioned below the heading */}
        <video
          controls
          autoPlay
          loop
          style={{
            position: 'absolute',
            top: '60px',  // Pushed 180px down so it won't overlap the heading
            left: '50%',
            transform: 'translateX(-50%)', // Centers horizontally
            width: '75%',
            borderRadius: '8px'
          }}
        >
          <source src={video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>



    </div>
  );
}
